// src/Header.js
import React from 'react';
import { Link } from 'react-router-dom';

const Header = ({ onLogout }) => {
    return (
        <div className="chat-header">
            LG Assistant
            {/* <nav>
                <Link to="/image-chat">Image Generation</Link>
            </nav> */}
            <nav>
                <Link to="/"> Chat</Link>
            </nav>
            <button className="logout-button" onClick={onLogout}>
                Logout
            </button>
        </div>
    );
};

export default Header;
